import { AppIcons } from '@web/ui/core/atoms';
import { agentKindIcon, twcn } from '@web/ui/core/utils';

interface RoleBadgeProps {
  /** Display name on the chip. */
  name: string;
  /** `agent` gets aubergine tint; `operator` keeps muted neutral. */
  kind: 'agent' | 'operator';
}

/**
 * Role badge — an inline chip with a kind icon (sparkle for AI, headset for
 * human) + display name. Used on the conversa card footer (driver of the most
 * recent active task) and on the tarefa card when no context chip applies.
 */
export function RoleBadge({ name, kind }: Readonly<RoleBadgeProps>): React.JSX.Element {
  const isAi = kind === 'agent';
  return (
    <span
      className={twcn(
        'inline-flex items-center gap-1.25 h-5.5 pl-pill-track pr-2 rounded-sm border',
        isAi
          ? 'bg-ai-tint text-ai-ink border-ai/20'
          : 'bg-muted text-foreground border-border-soft',
      )}
    >
      <span
        className={twcn(
          'inline-flex items-center justify-center w-4.25 h-4.25 rounded-sm',
          isAi ? 'bg-surface text-ai' : 'bg-surface text-foreground',
        )}
      >
        <AppIcons name={agentKindIcon(kind)} size={11} />
      </span>
      <span className="text-micro font-medium leading-none">{name}</span>
    </span>
  );
}
